import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {StarRounded} from 'views/icons';
import {Translate} from 'views/module';

const PlanPriceCard = (props) => {
  const {
    title,
    subtitle,
    description,
    recommended,
  } = props;

  return (
    <Box
      sx={{
        p: '24px',
        borderRadius: '24px',
        border: recommended ? '1px solid #EDC0AD' : '1px solid transparent',
        backgroundColor: recommended ? '#F6F2EF66' : '#F8F5F2',
        gap: '12px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
        {
          recommended && (
            <Box sx={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <StarRounded sx={{fontSize: '16px', color: '#DA7955'}} />

              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 590,
                  lineHeight: '100%',
                  letterSpacing: '4%',
                  color: '#DA7955',
                  textTransform: 'uppercase',
                }}
              >
                <Translate expression={'schedulestep.PlansCard.RecommendedForYou'} />
              </Typography>
            </Box>
          )
        }

        <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
          {title}
        </Typography>

        {
          subtitle && (
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 600,
                lineHeight: '100%',
                letterSpacing: '4%',
                color: '#919191',
                textTransform: 'uppercase',
              }}
            >
              {subtitle}
            </Typography>
          )
        }
      </Box>

      <Typography
        sx={{
          fontSize: '16px',
          lineHeight: '150%',
          fontWeight: 400,
          color: '#2D2925A3',
          pr: '32px',
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

PlanPriceCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  description: PropTypes.string.isRequired,
  recommended: PropTypes.bool,
};

export default React.memo(PlanPriceCard);
